
import { Component, Vue } from 'vue-property-decorator'
import TotalStat from './components/totalStat.vue'
import NewsList from './components/newsList.vue'
import OthersStat from './components/othersStat.vue'
import { IStatData, INewsData } from '@/types/home-types'
import { HomeService } from '@/services/index'

const stat = { 
    news_count: 0,
    reporter_count: 0,
    media_count: 0
}

@Component({
    name: 'Dashboard',
    components: {
        TotalStat,
        NewsList,
        OthersStat
    }
})
export default class extends Vue {
    private totalStat: IStatData = stat
    private todayStat: IStatData = stat
    private newsList: INewsData[] = []
    private bugCount: Number = 0

    mounted() {
        this.fetchStat()
    }

    private async fetchStat() {
        const result = await HomeService.getHomeStat()
        if (result.status === 200) {
            const { total_stat, today_stat, news_list, bug_count } = result.data
            this.totalStat = total_stat
            this.todayStat = today_stat
            this.newsList = news_list
            this.bugCount = bug_count
        }
    }
}
